export enum AutomationExternalTaskProcessingSkipReason {
  component_off = "component_off",
  entity_enr_criteria_fail = "entity_enr_criteria_fail",
  no_property = "no_property",
  smart_send = "smart_send",
  no_email = "no_email",
  user_unsub = "user_unsub",
  direct_mail_unsub = "direct_mail_unsub",
  email_inv = "email_inv",
  plan_inactive = "plan_inactive",
  override_contact_owner_flag_inactive = "override_contact_owner_flag_inactive",
  contact_owner_unchanged = "contact_owner_unchanged",
  rotate_contact_owner_action_empty_agent_list = "rotate_contact_owner_action_empty_agent_list"
}
export const AutomationExternalTaskProcessingSkipReasonToLabelMapping: Record<AutomationExternalTaskProcessingSkipReason, string> = {
  [AutomationExternalTaskProcessingSkipReason.component_off]: "Action Disabled",
  [AutomationExternalTaskProcessingSkipReason.entity_enr_criteria_fail]: "Enrollment Criteria",
  [AutomationExternalTaskProcessingSkipReason.no_property]: "Property not present",
  [AutomationExternalTaskProcessingSkipReason.smart_send]: "Smart Send",
  [AutomationExternalTaskProcessingSkipReason.no_email]: "No Email",
  [AutomationExternalTaskProcessingSkipReason.user_unsub]: "User Unsubscribed email",
  [AutomationExternalTaskProcessingSkipReason.direct_mail_unsub]: "Direct Mail Unsubscribed",
  [AutomationExternalTaskProcessingSkipReason.email_inv]: "Invalid Email",
  [AutomationExternalTaskProcessingSkipReason.plan_inactive]: "Account Subscription Inactive",
  [AutomationExternalTaskProcessingSkipReason.contact_owner_unchanged]: "Contact Owner Unchanged",
  [AutomationExternalTaskProcessingSkipReason.override_contact_owner_flag_inactive]: "Override Contact Owner Flag Inactive",
  [AutomationExternalTaskProcessingSkipReason.rotate_contact_owner_action_empty_agent_list]: "Rotate Contact Owner Action Empty Agent List"
};
